// extracted by mini-css-extract-plugin
export default {"noItems":"shortlist_empty_state-module___noItems___c3c9560c","subtitle":"shortlist_empty_state-module___subtitle___a24f8aed"};